import bowser from 'bowser';
import { useEffect } from 'react';
import useWindowSize from '../hooks/useWindowSize';
import useMount from '../hooks/useMount';

export default function useViewportCustomProperties(): void {
  const windowSize = useWindowSize();

  useMount(() => {
    // (document as HTMLDocument).documentElement.style.setProperty('--vh', `${windowSize.height * 0.01}px`);
    // (document as HTMLDocument).documentElement.style.setProperty('--vw', `${windowSize.width * 0.01}px`);
  });

  useEffect(() => {
    if (!bowser.ios)
      (document as HTMLDocument).documentElement.style.setProperty(
        '--vh',
        `${windowSize.height * 0.01}px`,
      );
    (document as HTMLDocument).documentElement.style.setProperty(
      '--vw',
      `${windowSize.width * 0.01}px`,
    );
  }, [windowSize.height, windowSize.width]);
}
